import styled from 'styled-components';

export const PreviewText = styled.div`
    font-style: italic;
    color: #555;
`;
